import moment from 'moment';
import React from 'react';
import { useLoad } from '../../collection/Hooks';
import Loading from '../../collection/icons/Loading';
import { BsFormControl, BsFormSelect, BsModalForm } from '../../collection/bootstrap/BootstrapComponents';
import { apiForm, apiGet } from '../../utils/api';

export default function PermisoModal(props) {
    const isNew = props.idPermiso < 1;

    const updateData = async () => await apiGet("permisos/get/" + props.idPermiso);

    const checkData = formData => {
        let errors = {};
        // Fecha y horas
        const fecha = formData.get("fecha");
        const horaInicio = formData.get("horaInicio");
        const horaFin = formData.get("horaFin");
        if (!fecha) {
            errors["fecha"] = "Campo obligatorio";
        }
        if (!horaInicio) {
            errors["horaInicio"] = "Campo obligatorio";
        }
        if (!horaFin) {
            errors["horaFin"] = "Campo obligatorio";
        }
        if (fecha) {
            if (horaInicio) {
                const fhi = moment(fecha + ' ' + horaInicio);
                if (!fhi.isValid(fhi)) {
                    errors["horaInicio"] = "Fecha y hora no válidas";
                }
            }
            if (horaFin) {
                const fhf = moment(fecha + ' ' + horaFin);
                if (!fhf.isValid(fhf)) {
                    errors["horaFin"] = "Fecha y hora no válidas";
                }
            }
        }
        // Justificante
        const justificante = formData.get("justificante");
        if (isNew && justificante.size == 0) {
            errors["justificante"] = "Campo obligatorio";
        }
        // Trabajador
        if (props.super) {
            const trabajador = formData.get("trabajador");
            if (!trabajador) {
                errors["trabajador"] = "Campo obligatorio";
            }
        }
        return errors;
    }

    const saveData = async data => {
        const action = isNew ? "new" : "edit";
        const result = await apiForm("permisos/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nuevo permiso" : "Editar permiso"}
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            {props.super ? <PermisoFormSuper permisoAdmin={props.permisoAdmin} /> : <PermisoForm />}
        </BsModalForm>
    );
}

function PermisoForm(props) {
    const data = props.data;
    const errors = props.errors;
    return <>
        <BsFormControl
            /* Fecha */
            label="Fecha" name="fecha"
            value={data.fecha} error={errors.fecha}
            type="date" />
        <BsFormControl
            /* Hora inicio */
            label="Inicio" name="horaInicio"
            value={data.horaInicioStr} error={errors.horaInicio}
            className="mt-3" type="time" />
        <BsFormControl
            /* Hora fin */
            label="Final" name="horaFin"
            value={data.horaFinStr} error={errors.horaFin}
            className="mt-3" type="time" />
        <BsFormControl
            /* Justificante */
            label="Justificante" name="justificante"
            value="" error={errors.justificante}
            className="mt-3" type="file" />
        <BsFormControl
            /* Comentario */
            label="Comentario" name="comentario"
            value={data.comentario} error={errors.comentario}
            className="mt-3" maxLength="250" as="textarea" />
    </>;
}

function PermisoFormSuper(props) {
    const data = props.data;
    const errors = props.errors;
    const [userList, reload] = useLoad(async () => { return await apiGet(props.permisoAdmin ? "usuarios/list" : "usuarios/listtrabajadores")});

    return userList ? <>
        <BsFormSelect
            /* Trabajador */
            label="Trabajador" name="trabajador"
            value={data.trabajador} error={errors.trabajador}
            options={userList} />
        <BsFormControl
            /* Fecha */
            label="Fecha" name="fecha"
            value={data.fecha} error={errors.fecha}
            type="date" className="mt-3" />
        <BsFormControl
            /* Hora inicio */
            label="Inicio" name="horaInicio"
            value={data.horaInicioStr} error={errors.horaInicio}
            className="mt-3" type="time" />
        <BsFormControl
            /* Hora fin */
            label="Final" name="horaFin"
            value={data.horaFinStr} error={errors.horaFin}
            className="mt-3" type="time" />
        <BsFormControl
            /* Justificante */
            label="Justificante" name="justificante"
            value="" error={errors.justificante}
            className="mt-3" type="file" />
        <BsFormControl
            /* Comentario */
            label="Comentario" name="comentario"
            value={data.comentario} error={errors.comentario}
            className="mt-3" maxLength="250" as="textarea" />
    </> : <Loading />;
}
